module.exports = Object.freeze({
  gender: ['MALE', 'FEMALE'],
  age_group: [
    'BELOW10',
    'FROM10_TO19',
    'FROM20_TO29',
    'FROM30_TO39',
    'FROM40_TO49',
    'OVER50',
  ],
  scalp_type: [
    'GENERAL',
    'DRY',
    'OILY',
    'SENSITIVITY',
    'SEBORRHEIC',
    'UNKNOWN',
  ],
  hair_loss_type: [
    'THINNING_HAIR',
    'M',
    'O',
    'M_AND_O',
    'MIDDLE',
    'U',
    'POSTPARTUM',
    'PARTIAL',
    'CROWN',
    'NONE',
  ],
  hair_loss_family_history: [
    'none',
    'parents',
    'grandparents',
    'maternal_grandparents',
  ],
  scalp_issue: [
    'NONE',
    'INFLAMMATION',
    'PIMPLE',
    'SEBUM',
    'DRYNESS',
    'ITCHING',
    'SMELL',
    'GREASY',
    'SCALP_FEVER',
    'DRY_DANDRUFF',
    'OILY_DANDRUFF',
  ],
  shampoo_preference: [
    'DETERGENCY',
    'NATURAL',
    'COOLING',
    'HAIRLOSS_FUNCTION',
    'VEGAN',
    'FRAGRANCE',
  ],
  hair_preference: ['STIFF', 'SOFT'],
  lifestyle: ['dyeing', 'perm', 'wash_hair_cycle'],
  optional_lifestyle: [
    'smoking',
    'drinking',
    'coffee',
    'sleep_time',
    'outdoor_time',
    'stress',
    'styling_product',
    'night_shampoo',
    'treatment_product',
    'scalp_nutrition',
    'pregnant',
    'drug',
  ],
  mapper: {
    WashHairCycle: ['ONCE_IN_A_WHILE', 'ONCE_A_DAY', 'TWICE_A_DAY'],
    NoneOrPeriodical: ['NONE', 'LESS_THAN_THREE', 'MORE_THAN_THREE'],
    SleepType: ['LESS_THAN_FIVE', 'FIVE_TO_EIGHT', 'EIGHT_OR_MORE'],
    OutdoorType: ['LESS_THAN_FIVE', 'FIVE_TO_EIGHT', 'EIGHT_OR_MORE'],
  },
  group: [
    'SURFACTANT',
    'PH_ADJUSTER',
    'KERATOLYTIC',
    'ANTIOXIDANT_ANTIMICROBIAL',
    'COOLING',
    'PROTECTING_AGENT',
    'ACNE_SEBUG_AGENT',
    'ANTISEPTIC_PRESERVATIVE',
    'SILICON_PEG',
    'FRAGRANCE',
    'ALCOHOL',
    'PIGMENT',
    'FILM',
    'ANTISEBORRHOEIC',
    'FUNCTIONAL_AGENT',
    'DISTILLED_WATER',
    'NOT_AVAILABLE',
  ],
  sub_group: [
    'ANIONIC_SURFACTANT',
    'ANIONIC_SURFACTANT_ORGANIC',
    'ANIONIC_SURFACTANT_MINUS',
    'AMPHOTERIC_SURFACTANT',
    'CATIONIC_SURFACTANT',
    'NONIONIC_SURFACTANT',
    'SUPPLEMENT_AGENT',
    'STRONG_ACID',
    'WEAK_ACID',
    'STRONG_AHA',
    'STRONG_BHA',
    'SOFT_PHA',
    'ANTIOXIDANT',
    'ANTIBACTERIA_DEODORANT',
    'ORGANIC_COOLING',
    'CHEMICAL_COOLING',
    'HUMECTANT',
    'EMOLLIENT',
    'OIL',
    'BIOTIN_YEAST_BLACKBEAN',
    'ANTI_INFLAMMATION',
    'SEBUM_CONTROL',
    'CHEMICAL_ANTISEPTIC',
    'ORGANIC_PRESERVATIVE',
    'SILICON',
    'PEG',
    'ARTIFICIAL_FRAGRANCE',
    'ORGANIC_FRAGRANCE',
    'ALCOHOL',
    'CHEMICAL_PIGMENT',
    'ORGANIC_PIGMENT',
    'FILM_FORMING',
    'ANTI-SEBORRHOEIC',
    'UV_PROTECT',
    'SKIN_PROTECTION',
    'AMINO_ACID',
    'HAIRLOSS_PREVENTION_AGENT',
    'DANDRUFF_PREVENTION_AGENT',
    'DISTILLED_WATER',
    'NOT_AVAILABLE',
  ],
  features: [
    'caution_toxic',
    'caution_cancer',
    'caution_allergic',
    'caution_skin_irritating',
    'caution_ko20',
    'allergic_ko26',
    'hairloss_ko',
  ],
  shampoo_properties: [
    'hairloss',
    'ewg_over80',
    'vegan',
    'caution_20',
    'allergic_26',
  ],
});
